import { lazy } from 'react';

export const Attachments = lazy(() => import('./ui/Attachments'));
